import CategoryPage from '../components/CategoryPage';

export default function Others() {
  return <CategoryPage type="other" title="Other" />;
}
